import { Schedule } from '@app/models/payroll/schedule.model';
import { PayrollReport } from '@reporting/interfaces/report.interface';
import { format } from 'date-fns';
import moment from 'moment';

export class PayrollRegister implements PayrollReport {
    name = 'reporting.payroll.payrollRegister.name';
    description = 'reporting.payroll.payrollRegister.description';
    routerLink = 'payroll-register';
    apiEndpoint = 'payroll/payrollRegister';
    allowsInclusionOfPendingPayrolls = true;
    hasExcel = true;
    hasPDF = true;
    hasCSV = false;
    showsPeriod = true;
    filterable = true;

    get fileName(): string {
        return `humi_payroll_register_report_${format(new Date(), 'YYYY_MM_DD')}`;
    }

    getInitialDates(schedule?: Schedule): [Date, Date] {
        let chequeDate = moment().startOf('year').toDate();
        const lastPendingPayroll = schedule?.lastPendingPeriod;
        const lastPaidPayroll = schedule?.lastPaidPeriod;

        if (lastPendingPayroll) {
            chequeDate = moment(lastPendingPayroll.chequeDate).toDate();
        }

        if (lastPaidPayroll) {
            chequeDate = moment(lastPaidPayroll.chequeDate).toDate();
        }

        return [chequeDate, chequeDate];
    }
}
